export default "__VITE_ASSET__8e684dae__"